import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { endpoints } from "../../api/endpoints";

export const fetchUniversities = createAsyncThunk(
  "university/fetchUniversities",
  async (formData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.getuniversities,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Something went wrong"
      );
    }
  }
);
export const fetchUniversitiesDegrees = createAsyncThunk(
  "university/fetchUniversitiesDegrees",
  async (formData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.getuniversitydegrees,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Something went wrong"
      );
    }
  }
);

const universitySlice = createSlice({
  name: "university",
  initialState: {
    universities: [],
    degrees: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUniversities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUniversities.fulfilled, (state, action) => {
        state.loading = false;
        state.universities = action.payload.data.map((item) => ({
          value: item.name,
          label: item.name,
        }));
      })
      .addCase(fetchUniversities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch universities";
      })
      .addCase(fetchUniversitiesDegrees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUniversitiesDegrees.fulfilled, (state, action) => {
        state.loading = false;
        state.degrees = action.payload.data.map((item) => ({
          value: item.degree_title,
          label: item.degree_title,
        }));
      })
      .addCase(fetchUniversitiesDegrees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch degrees";
      });
  },
});

export default universitySlice.reducer;
